<template>
  <json-editor
    :label="label"
    :classes="classes"
    :input-value="inputValue"
    :is-update-in-process="planetStore.isUpdateInProcess"
    @update:input-value="emit('update:inputValue', $event)"
    @invalid="emit('invalid', $event)"
  >
  </json-editor>
</template>

<script setup lang="ts">
import JsonEditor from 'ui-component-library/rbz/components/JsonEditor.vue';
import { usePlanetStore } from '@/store/PlanetStore';

interface RbzJsonField {
  label: string;
  classes?: string;
  inputValue?: string | null;
  isUpdateInProcess?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<RbzJsonField>(), {
  classes: '',
  inputValue: null,
});

interface RbzJsonFieldEmits {
  (e: 'update:inputValue', value: string | number): void;

  (e: 'invalid', value: boolean): void;
}

const emit = defineEmits<RbzJsonFieldEmits>();
const planetStore = usePlanetStore();
</script>
